export const DETECTION_FILTERS = {
  EXCLUDE_MISDETECTION: 'exclude_misdetection',
  PICKUP_ONLY: 'pickup_only',
  ALL: 'all',
};
